<script setup lang="ts">
import { handleHtmlImg } from '@/utils/notify';

defineProps<{ contentHtml?: string }>();
</script>

<template>
  <div
    class="html-content ck-content"
    @click="(e) => handleHtmlImg(e, contentHtml)"
    v-html="contentHtml"
  />
</template>

<style scoped lang="scss">
:deep(img) {
  max-width: 100%;
}

.html-content {
  margin-inline-end: 34px;
}
</style>
